import * as React from 'react';

const ZoomPlusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <g clipPath='url(#clip0_10066_28872)'>
      <path
        d='M13.2635 10.7359L13.2635 2.58398L10.7349 3.42684L10.7349 10.7359L2.69922 10.7359L2.69922 13.2645L10.7349 13.2645V21.4164L13.2635 20.5736V13.2645H21.2992V10.7359H13.2635Z'
        fill='#200000'
      />
    </g>
    <defs>
      <clipPath id='clip0_10066_28872'>
        <rect width='24' height='24' fill='#200000' />
      </clipPath>
    </defs>
  </svg>
);

export default ZoomPlusIcon;
